import React from 'react';
import styles from './HeaderCentered.module.scss';

function HeaderCentered (props) {
    const { className, children } = props;

    return <h2 className={[className, styles.HeaderCentered].join(' ')}>{children}</h2>


};

export default HeaderCentered;
